import { render } from "./shopMenusEditor.vue?vue&type=template&id=f46b1184"
import script from "./shopMenusEditor.vue?vue&type=script&lang=js"
export * from "./shopMenusEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__